import { useEffect, type CSSProperties } from 'react';

// How large the builder's chrome is drawn over a page the builder has shrunk to fit its canvas. The page is
// laid out at a real desktop width and only its picture is scaled down, so a 26px toolbar drawn inside it
// arrives on screen at a third of that and its buttons stop being targets. Drawn this many times larger, the
// toolbar, the name tag and the `+` come out at their true size, as Shopify's do over its scaled preview.

/** The most the chrome is enlarged, so a canvas squeezed to a sliver never draws a toolbar wider than the page. */
const MOST = 3;

// Reads how much larger the chrome is drawn from how far the builder shrinks the page; 1 when it does not.
export function chromeZoom(scale: number | undefined): number {
  if (!scale || scale >= 1) return 1;
  return Math.min(MOST, 1 / scale);
}

// Hands the zoom to the chrome sized in CSS — the `+` and the drop marks — through a variable on the page's root.
export function useRootZoom(zoom: number): void {
  useEffect(() => { document.documentElement.style.setProperty('--xs-chrome-zoom', String(zoom)); }, [zoom]);
}

// Positions a piece of chrome at its spot and enlarges it from that corner, so the spot stays where it was placed.
export const zoomedSpot = (top: number, left: number, zoom: number): CSSProperties =>
  (zoom === 1 ? { top, left } : { top, left, transform: `scale(${zoom})`, transformOrigin: 'top left' });
